export default __webpack_public_path__ + "static/media/Whistleblowing_3_(EN).f8339374.mp4";